import { useNavigate } from "react-router-dom";
import { Info, CaretLeft } from "@phosphor-icons/react";

/**
 * Big prominent "About" CTA — replaces the small text link on public auth pages.
 * Full-width, gold-bordered, RTL-first, with hover lift effect.
 */
export default function AboutBigButton({ className = "" }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/about")}
      data-testid="goto-about"
      dir="rtl"
      className={`w-full mt-6 mb-3 group flex flex-row-reverse items-center gap-4 px-5 py-4 rounded-xl border-2 border-primary bg-primary/15 hover:bg-primary/25 shadow-[0_4px_14px_rgba(201,169,97,0.25)] hover:shadow-[0_6px_20px_rgba(201,169,97,0.4)] hover:-translate-y-0.5 transition-all ${className}`}
    >
      <div className="w-11 h-11 rounded-full bg-[#1A2A48] border border-primary flex items-center justify-center shrink-0">
        <Info size={26} weight="duotone" className="text-primary" />
      </div>
      <div className="flex-1 text-right">
        <div className="text-primary text-lg font-bold leading-tight">عن شركة مراسم الزوار</div>
        <div className="text-white/55 text-xs mt-0.5">خدماتنا · أسطولنا · التواصل معنا</div>
      </div>
      <CaretLeft size={22} weight="bold" className="text-primary shrink-0 group-hover:-translate-x-1 transition-transform" />
    </button>
  );
}
